import { Box, Divider, Flex, Stack, Text } from '@agrotoken-tech/ui';
import { PropsWithChildren, ReactNode } from 'react';

type Props = {
  title: string;
  badge?: ReactNode;
  action?: ReactNode;
};

export const FormSection = ({
  title,
  badge,
  action,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Stack>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify={{ base: 'start', md: 'space-between' }}
        alignItems={{ base: 'start', md: 'center' }}
        mb={2}
      >
        <Flex gap={2} alignItems="center" mb={{ base: 4, sm: 0 }}>
          <Text size={'md'} variant="medium">
            {title}
          </Text>
          {badge}
        </Flex>
        <Flex w={{ base: '100%', sm: 'auto' }} justify="center">
          {action}
        </Flex>
      </Flex>
      <Divider />
      <Box>{children}</Box>
    </Stack>
  );
};
